<template>
  <div class="dialog_sueecss_pc">
    <div class="sueecss_box">
      <div class="qr-code">
        <div class="img-wrap">
          <img class="qr-code-img" :src="qrCodeUrl" alt="" />
        </div>

        <div class="title">扫码添加，随时咨询</div>
      </div>
      <div class="dialog-close" @click="() => this.$emit('closeform')"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    qrCodeUrl: {
      // 使用带有卫瓴二维码的弹框
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="less" scoped>
// pc样式
.dialog_sueecss_pc {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.45);
  z-index: 999999;

  .dialog-close {
    width: 30px;
    height: 30px;
    background: url('../assets/images/semsal/close.png') top right / cover no-repeat;
    position: absolute;
    top: 306px;
    right: 106px;
    cursor: pointer;
  }

  .sueecss_box {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 244px;
    height: 294px;
    font-size: 18px;
    font-weight: 500;
    color: #000;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    background: url('../assets/images/semsal/qrcodebg.png') center right / cover no-repeat;

    .qr-code {
      text-align: center;
      .img-wrap {
        width: 198px;
        height: 198px;
        background: #ffffff;
        border-radius: 16px;
        padding: 6px;
        margin-top: 23px;
        .qr-code-img {
          width: 186px;
          height: 186px;
        }
      }

      .title {
        margin-top: 15px;
      }
    }
  }
}
</style>
